import { isNonEmptyArray } from "../../../../../common/utils";

export const getValueByUuid = (field, data) => {
	for (const project of data) {
		for (const key in project) {
			if (project[key].fieldUuid === field.id) {
				const { type } = field;
				switch (type) {
					case "TEXT":
						return project[key].value;
					case "NUMBER":
						return project[key].value;
					case "DATETIME":
						return new Date(project[key].value).toLocaleDateString("en-CA");
					case "TREE":
						return project[key].value.toString();
					default:
						return "-";
				}
			}
		}
	}
	return null;
};
export const preparePayload = (filters, sorting) => {
	let payload = {};
	const uuidToValues = Object.keys(filters).filter((key) => key !== "content" && key !== "projectStatus");
	if (filters.content !== undefined) {
		payload = { ...payload, content: filters?.content };
	}
	if (filters.projectStatus !== undefined) {
		payload = { ...payload, projectStatus: filters?.projectStatus };
	}
	if (isNonEmptyArray(uuidToValues)) {
		uuidToValues.forEach((uuidToValue) => {
			payload = {
				...payload,
				uuidToValue: {
					...payload.uuidToValue,
					[uuidToValue]: filters[uuidToValue],
				},
			};
		});
	}
	if (sorting) {
		payload = {
			...payload,
			sorting,
		};
	}
	return payload;
};
